import React from 'react';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { SloganMarquee } from '../components/SloganMarquee';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { Pricing } from '../components/Pricing';
import { Testimonials } from '../components/Testimonials';
import { CTASection } from '../components/CTASection';
export function Home() {
  return <main data-id="element-455">
      <Hero data-id="element-456" />
      <Stats data-id="element-457" />
      <SloganMarquee data-id="element-458" />
      <Services data-id="element-459" />
      <Process data-id="element-460" />
      <Pricing data-id="element-461" />
      <Testimonials data-id="element-462" />
      <CTASection data-id="element-463" />
    </main>;
}